import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
  const [pageContext, setPageContext] = useState(null);

  const clearPageContext = useCallback(() => setPageContext(null), []);

  return (
    <ChatContext.Provider value={{ pageContext, setPageContext, clearPageContext }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useChatContext must be used inside <ChatProvider>');
  return ctx;
};

// Convenience hook for pages: sets context on mount (and when `value` changes)
// and clears it automatically on unmount. Keeps the widget in sync without
// each page having to remember to reset on navigation.
export const useSetPageContext = (value) => {
  const { setPageContext, clearPageContext } = useChatContext();
  useEffect(() => {
    if (value) setPageContext(value);
    else clearPageContext();
    return () => clearPageContext();
  }, [value, setPageContext, clearPageContext]);
};
